import angular from 'angular';

import component from './section-heading.component';

const SectionHeading = angular
    .module('control-room.commons.basic.components.section-heading', [])
    .component('crSectionHeading', component);

export default SectionHeading;
